export enum APIStatusCode {
    Ok = 200,
    Created = 201,
    NoContent = 204,
    BadRequest = 400,
    Unauthorized = 401,
    Forbidden = 403,
    NotFound = 404,
    Conflict = 409,
}
export enum LogLevelName {
    Critical = 'Critical',
    Error = 'Error',
    Warning = 'Warning',
}


export enum LogLevel {
    Trace = 0,
    Debug = 1,
    Information = 2,
    Warning = 3,
    Error = 4,
    Critical = 5,
    None = 6,
}
export enum LogLevelStyles {
    "log-warning" = 3,
    "log-error" = 4,
    "log-critical" = 5,
    "log-information"=2,
    "log-debug" = 1,
    "log-trace" = 0
}

export enum LogdotStyles {
    "dot-warning" = 3,
    "dot-error" = 4,
    "dot-critical" = 5,
    "dot-information"=2,
    "dot-debug" = 1,
    "dot-trace" = 0
}
export enum timeUnit {
    minute = 'minute',
    day = 'day',
    hour = 'hour',
    month = 'month',
    year = 'year'
}

export enum Permissions {
    CanEditEstablishments = "canEditEstablishments",
    CanViewEstablishments = "canViewEstablishments",
    CanManageRoles = "canManageRoles",
    CanAssignMyRoles = "canAssignMyRoles",
    CanAssignAnyRoles = "canAssignAnyRoles",
    CanViewUsers = "canViewUsers",
    CanViewDashboard = "canViewDashboard",
    CanViewHealthboard = "canViewHealthboard",
    CanManagePeople = "canManagePeople",
    CanRequeueSync = "canRequeueSync",
    CanManageArborKeys = "canManageArborKeys"
}

export enum MisType {
    Unknown = 0,
    Sims = 1,
    Arbor = 2,
    Bromcom = 3
}

export enum MisTypeFilter {
    Sims = 1,
    Arbor = 2,
    Bromcom = 3
}

export enum QueueStatus {
    NotExecuted = 1,
    Failed = 2,
    Completed = 3,
    InProgress = 4
}

export enum QueueLifecycleStatus {
    Waiting = 0,
    InProgress = 1,
    Completed = 2,
    Failed = 3
}

export enum TaskFailureCategory {
    Validation = 1,
    ServiceBus = 2,
    Execution = 3
}

export enum TaskType {
    Echo = -1,
    ExtractMisLocally = 1,
    ExtractMisCloud = 2,
    AttendanceSync = 4
}

export enum QueueStatusStyles {
    "queue-notexecuted" = 1,
    "queue-failed" = 2,
    "queue-completed" = 3,
    "queue-inprogress" = 4
}

export enum MisServiceType{
    Task = 'Task',
    Extract = 'Extract',
    Transform = 'Transform'
}

export enum UserTypeRepresents {
    STAFF = 'STAFF',
    STUDENT = 'STUDENT',
    ADMIN = 'ADMIN',
    UNKNOWN = 'UNKNOWN'
}

export enum PauseSyncDuration{
    Hours4 = "4h",
    Hours12 = "12h",
    Hours24 = "24h",
    Week1 = "1w",
    Week2 = "2w",
    Month1 = "1m"
}

export enum SyncType{
    RunSync = "run",
    ForceRefresh = "refresh",
    PauseSync = "pause"
}

export enum FilterTableCallFrom{
    Healthboard = "1",
    ForceRefresh = "2",
    ExtractedData = "3",
    Establishment = "4"
}

export enum StandardMappingTemplates
{
    None,
    Student,
    Staff,
    Applicants
}
export enum SalesForceCaseID
{
    CaseID = "CaseID",
    CaseIDNull = "CaseIDNull",
    CaseIDBlank = "CaseIDBlank",
    
}

export enum ExtractedPersonFieldTypes
{
    MisID,
    MisID2,
    Title,
    Surname,
    FirstName,
    LegalSurname,
    LegalFirstName,
    Year,
    RegClass,
    DateOfBirth,
    Gender,
    IsFsm,
    DateFsmExpiry,
    AdmissionNumber,
    StaffCode,
    PhotoID,
    PhotoImage,
    DietaryPreferences,
    DietaryNeeds,
    ParentalConsent,
    Upn
}

export enum ExtractStatus {
    None = 0,
    Active = 1,
    Inactive = 3
}

export enum ExtractStatusStyles {
    "None" = 0,
    "status-green" = 1,
    "status-amber" = 2,
    "status-red" = 3
}

export enum SortOrder {
    ASC = "ASC",
    DESC = "DESC",
    NONE = "NONE"
}

export enum ModalTypes {
    Add = 1,
    Edit = 2,
    Delete = 3
}

export enum EstablishmentDataType {
    RowXML = "raw-xml",
    RowData = "raw-data",
    Transform = "transform",
    TransformFinal = "transform-final"
}

export enum EstablishmentMisStatus
{
    Disabled,
    Paused,
    Enabled,
    Migrating
}

export enum ExtractClientStatus {
    Paused = 0,
    Ingest = 1,
    Active = 2
}

export const ExtractClientStatusLabels: Record<ExtractClientStatus, string> = {
    [ExtractClientStatus.Paused]: "Paused",
    [ExtractClientStatus.Ingest]: "Ingest",
    [ExtractClientStatus.Active]: "Active"
};

export const ExtractClientStatusConfirmMessages: Record<ExtractClientStatus, string> = {
    [ExtractClientStatus.Paused]: "When paused, this extract will no longer ingest data from the provider while paused.",
    [ExtractClientStatus.Ingest]: "When set to Ingest, this extract will ingest data from the provider but not process them into transformed records.",
    [ExtractClientStatus.Active]: "When set to active, this extract will pause any extracts that are set to active and will ingest and process records for retrieval from any connected applications."
};